module.exports = __webpack_public_path__ + "static/media/weather.2cd765a8.png";